import {
  CheckmarkOutline,
  CircleDash,
  Error,
  SubtractAlt,
  Warning,
  WarningAlt,
} from '@carbon/react/icons';
import { FloatingTooltip } from 'components/floating-tooltip/floating-tooltip';
import { WellboreGeometryStatus } from 'types/api-responses';

import styles from './wellbores-table.module.scss';

interface GeometryStatusCellProps {
  status: WellboreGeometryStatus;
  comment: string | null;
  // Display value when status is null. Drilled rows default to 'N/A';
  // predrill rows pass '--' to mean "pending" rather than "not applicable".
  fallback?: string;
}

export const GeometryStatusCell = ({
  status,
  comment,
  fallback = 'N/A',
}: GeometryStatusCellProps) => {
  switch (status) {
    case 'Valid':
      return (
        <div className={styles.statusCell}>
          <CheckmarkOutline className={styles.validIcon} />
          <span>Valid</span>
        </div>
      );
    case 'Invalid':
      return (
        <div className={styles.statusCell}>
          <FloatingTooltip
            content={comment || 'Invalid geometry'}
            placement="top"
          >
            <Warning className={styles.invalidIcon} />
          </FloatingTooltip>
          <span>Invalid</span>
        </div>
      );
    case 'Warning':
      return (
        <div className={styles.statusCell}>
          <FloatingTooltip content={comment || 'Warning'} placement="top">
            <WarningAlt className={styles.warningIcon} />
          </FloatingTooltip>
          <span>Warning</span>
        </div>
      );
    case 'Error':
      return (
        <div className={styles.statusCell}>
          <FloatingTooltip
            content={comment || 'Validation failed'}
            placement="top"
          >
            <Error className={styles.errorIcon} />
          </FloatingTooltip>
          <span>Error</span>
        </div>
      );
    case 'Processing':
      return (
        <div className={styles.statusCell}>
          <SubtractAlt className={styles.processingIcon} />
          <span>Processing</span>
        </div>
      );
    case 'Not Started':
      return (
        <div className={styles.statusCell}>
          <CircleDash className={styles.notStartedIcon} />
          <span>Not Started</span>
        </div>
      );
    case null:
      return (
        <div className={styles.statusCell}>
          <span>{fallback}</span>
        </div>
      );
    default:
      return <span>{status}</span>;
  }
};
